import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatButtonModule} from '@angular/material/button';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatIconModule} from '@angular/material/icon';
import {MatStepperModule} from '@angular/material/stepper';
import {WebcamModule} from 'ngx-webcam';
import {GoogleMapsModule} from '@angular/google-maps';

import {OnboardingContainerComponent} from './onboarding-container/onboarding-container.component';
import {WelcomeComponent} from './welcome/welcome.component';
import {DniFrontComponent} from './dni-front/dni-front.component';
import {DniBackComponent} from './dni-back/dni-back.component';
import {DniConfirmationComponent} from './dni-confirmation/dni-confirmation.component';
import {LivenessComponent} from './liveness/liveness.component';
import {PhoneComponent} from './phone/phone.component';
import {PhoneVerificationComponent} from './phone-verification/phone-verification.component';
import {EmailComponent} from './email/email.component';
import {EmailVerificationComponent} from './email-verification/email-verification.component';
import {LocationComponent} from './location/location.component';
import {ServicesComponent} from './services/services.component';
import {ReferencesComponent} from './references/references.component';
import {PasswordComponent} from './password/password.component';
import {ResultComponent} from './result/result.component';

@NgModule({
  declarations: [
    OnboardingContainerComponent,
    WelcomeComponent,
    DniFrontComponent,
    DniBackComponent,
    DniConfirmationComponent,
    LivenessComponent,
    PhoneComponent,
    PhoneVerificationComponent,
    EmailComponent,
    EmailVerificationComponent,
    LocationComponent,
    ServicesComponent,
    ReferencesComponent,
    PasswordComponent,
    ResultComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatCheckboxModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatStepperModule,
    WebcamModule,
    GoogleMapsModule,
    RouterModule,
  ],
})
export class OnboardingModule {}
